<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <mail-settings-create-or-update v-model="mailSettings" :errors="errors"></mail-settings-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-modal id="test-mail" title="Test Maili Gönder" no-close-on-esc no-close-on-backdrop>
            <mail-settings-test-mail v-model="testMailData" :errors="errors"></mail-settings-test-mail>
            <template #modal-footer><v-executer :loading="loading" text="Gönder" :action="sendTestMail"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="mail-settings"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
                    
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SystemDefinitionsApi from '@/api/system-definitions'
import MailSettingsCreateOrUpdate from './components/MailSettingsCreateOrUpdate.vue'
import MailSettingsTestMail from './components/MailSettingsTestMail.vue'

export default {
    components:{
        BCard,
        MailSettingsCreateOrUpdate,
        MailSettingsTestMail
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            mailSettings:{
                Id:0,
                MailName:null,
                SystemMailKeyId:null,
                MailAddress:"",
                Host:"",
                Port:0,
                Password:"",
                EnableSSL:true,
                Domain:null
            },
            testMailData:{
                Id:null,
                ToMail:null,
            },
            fields:[
                { name:"Mail Adı",key:"MailName", thClass:"w-25",tdClass:'text-nowrap',sortable:true},
                { name:"Mail Adresi",key:"MailAddress", thClass:"w-20",tdClass:'text-nowrap',sortable:true},
                { name:"Kullanım Amacı",key:"SystemMailKeyName", thClass:"w-20",tdClass:'text-nowrap',sortable:true, sortKey:'SystemMailKey.Name'},
                { name:"Sunucu",key:"Host", thClass:"w-20",sortable:true},
                { name:"Port",key:"Port",tdClass:"text-right", thClass:"w-10",sortable:true},
                { name:"SSL",key:"EnableSSL", thClass:"w-5",sortable:true}
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"Test Maili Gönder",key:"test-mail",icon:"SendIcon",variant:"success",action:this.testMail },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.mailSettings.Id = 0
            this.mailSettings.MailName = null  
            this.mailSettings.SystemMailKeyId=null
            this.mailSettings.MailAddress=""
            this.mailSettings.Host=""
            this.mailSettings.Port=0
            this.mailSettings.Password=""
            this.mailSettings.EnableSSL=true
            this.testMailData.Id = null
            this.testMailData.ToMail = null
            this.testMailData.Domain = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.mailSettings.Id = item.Id;
            this.mailSettings.MailName = item.MailName
            this.mailSettings.SystemMailKeyId=item.SystemMailKeyId;
            this.mailSettings.MailAddress=item.MailAddress;
            this.mailSettings.Host=item.Host;
            this.mailSettings.Port=item.Port;
            this.mailSettings.Password=item.Password;
            this.mailSettings.Domain = item.Domain;
            this.mailSettings.EnableSSL=item.EnableSSL;
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemDefinitionsApi.MailSettings.CreateOrUpdate(this.editing,this.mailSettings)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return SystemDefinitionsApi.MailSettings.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem "${item.MailName}" mailini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemDefinitionsApi.MailSettings.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        testMail(item){
            this.clearForm()
            this.testMailData.Id = item.Id
            this.$showModal("test-mail")
        },
        sendTestMail(){
            this.loading = true
            SystemDefinitionsApi.MailSettings.Test(this.testMailData.ToMail,this.testMailData.Id).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("test-mail")
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        }
    }
}
</script>

<style>

</style>